import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { PHONE_VERIFICATION_STEPS } from 'app/shared/constants/WizardStepsConstants';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import PostingActions from 'app/shared/actions/PostingActions';

import ContactInformationSF from './ContactInformationSF';
import ContactInformationMF from './ContactInformationMF';

const phoneVerificationConfig = [
    PHONE_VERIFICATION_STEPS.ADD_PHONE_NUMBER,
    PHONE_VERIFICATION_STEPS.GET_VERIFICATION_CODE,
    PHONE_VERIFICATION_STEPS.VERIFICATION_CODE_SENT,
    PHONE_VERIFICATION_STEPS.VERIFICATION_SUCCESS,
];

const ContactInformation = ({
    contactNameRef,
    contactPhoneRef,
    errorObj,
    formData,
    forRentByRef,
    immediateUpdateAndSave,
    isInputFormDisabled,
    isPaymentRequired,
    savePropertyData,
    updateErrorObj,
    updateFormData,
    updateOnFocus,
}) => {
    const dispatch = useDispatch();
    const {
        isCommunity,
        contactPhone,
        contactPhoneDateVerified,
        propertyId,
    } = formData;
    const [verifiedPhoneNumber, setVerifiedPhoneNumber] = useState('');
    const [datePhoneVerified, setDatePhoneVerified] = useState('');
    const [showPhoneVerificationModal, setShowPhoneVerificationModal] = useState(false);

    useEffect(() => {
        if (contactPhone) {
            setVerifiedPhoneNumber(contactPhone);
            setDatePhoneVerified(contactPhoneDateVerified || '');
        }
    }, []);

    const handleRequestVerificationCode = () => dispatch(
        analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.HPPP_VERIFICATION_REQUEST)
    );

    const handlePhoneNumberAdded = cleanPhoneNumber => dispatch(PostingActions.property.edit({
        fieldName: 'contactPhone',
        value: cleanPhoneNumber,
        propertyId,
    },
    {
        componentGroupName: AnalyticsConstants.LISTING_COMPONENT_GROUP_NAME.CONTACT_INFO,
        preserveFieldName: false,
    }))
        .then((result) => {
            const { response: { contactPhone, dateVerified } } = result;
            setVerifiedPhoneNumber(contactPhone);
            setDatePhoneVerified(dateVerified);
            updateFormData({ contactPhone });
            updateErrorObj({ contactPhone: null });
            return Promise.resolve();
        })
        .catch(err => Promise.reject(err));

    const handleVerificationConfirmation = phoneNumber => dispatch(PostingActions.property.edit({
        fieldName: 'contactPhone',
        value: phoneNumber,
        propertyId,
    }, {
        componentGroupName: AnalyticsConstants.LISTING_COMPONENT_GROUP_NAME.CONTACT_INFO,
    }))
        .then((result) => {
            dispatch(analyticsUtils.track.GAEventV2(
                AnalyticsConstants.GA_EVENTS.HPPP_VERIFICATION_SUCCESS
            ));

            const { response: { contactPhone: verifiedContactPhone, dateVerified } } = result;
            setVerifiedPhoneNumber(verifiedContactPhone);
            setDatePhoneVerified(dateVerified);
            updateFormData({ contactPhone: verifiedContactPhone });
            updateErrorObj({ contactPhone: null });

            return Promise.resolve();
        }).catch((error) => {
            dispatch(analyticsUtils.track.GAEventV2(
                AnalyticsConstants.GA_EVENTS.HPPP_VERIFICATION_ERROR
            ));

            return Promise.reject(error);
        });

    if (isCommunity) {
        return (
            <ContactInformationMF
                contactNameRef={contactNameRef}
                contactPhoneRef={contactPhoneRef}
                datePhoneVerified={datePhoneVerified}
                errorObj={errorObj}
                formData={formData}
                forRentByRef={forRentByRef}
                immediateUpdateAndSave={immediateUpdateAndSave}
                isInputFormDisabled={isInputFormDisabled}
                isPaymentRequired={isPaymentRequired}
                onPhoneNumberAdded={handlePhoneNumberAdded}
                onRequestVerificationCode={handleRequestVerificationCode}
                onVerificationConfirmation={handleVerificationConfirmation}
                phoneVerificationConfig={phoneVerificationConfig}
                savePropertyData={savePropertyData}
                setShowPhoneVerificationModal={setShowPhoneVerificationModal}
                showPhoneVerificationModal={showPhoneVerificationModal}
                updateFormData={updateFormData}
                updateOnFocus={updateOnFocus}
                verifiedPhoneNumber={verifiedPhoneNumber}
            />
        );
    }
    return (
        <ContactInformationSF
            contactNameRef={contactNameRef}
            contactPhoneRef={contactPhoneRef}
            datePhoneVerified={datePhoneVerified}
            errorObj={errorObj}
            formData={formData}
            forRentByRef={forRentByRef}
            immediateUpdateAndSave={immediateUpdateAndSave}
            isInputFormDisabled={isInputFormDisabled}
            isPaymentRequired={isPaymentRequired}
            onPhoneNumberAdded={handlePhoneNumberAdded}
            onRequestVerificationCode={handleRequestVerificationCode}
            onVerificationConfirmation={handleVerificationConfirmation}
            phoneVerificationConfig={phoneVerificationConfig}
            savePropertyData={savePropertyData}
            setShowPhoneVerificationModal={setShowPhoneVerificationModal}
            showPhoneVerificationModal={showPhoneVerificationModal}
            updateFormData={updateFormData}
            updateOnFocus={updateOnFocus}
            verifiedPhoneNumber={verifiedPhoneNumber}
        />
    );
};

export default ContactInformation;
